import { blue, deepPurple } from "@mui/material/colors";
import StatusChip from "@entrilia/shared/components/StatusChip";
import type { ThemeColorFn } from "@entrilia/shared/utilities/colorHelper";
import { makeModeAwareAccent } from "@entrilia/shared/utilities/colorHelper";
import type { DataCollectionRequestStatus } from "../../../../api/types/dataCollectionTypes";
import { dataCollectionRequestStatusCaptionsMap } from "../../../../utilities/enumCaptions";

interface Props {
  status: DataCollectionRequestStatus;
}

const colorsMaps: Record<DataCollectionRequestStatus, ThemeColorFn> = {
  Draft: (t) => t.palette.text.secondary,
  InProgress: (t) => makeModeAwareAccent(t, blue),
  Scheduled: (t) => makeModeAwareAccent(t, deepPurple),
  Completed: (t) => t.palette.success.main,
};

const DataRequestStatusTag = ({ status }: Props) => {
  return (
    <StatusChip label={dataCollectionRequestStatusCaptionsMap[status] ?? status} withDot color={colorsMaps[status]} />
  );
};

export default DataRequestStatusTag;
